import { render, staticRenderFns } from "./CommonStoreFooter.vue?vue&type=template&id=1b03dfe0&scoped=true"
import script from "./CommonStoreFooter.vue?vue&type=script&lang=js"
export * from "./CommonStoreFooter.vue?vue&type=script&lang=js"
import style0 from "./CommonStoreFooter.vue?vue&type=style&index=0&id=1b03dfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b03dfe0",
  null
  
)

export default component.exports